export default __webpack_public_path__ + "static/media/excel2020.2da3a8a2.png";